import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { EntidadEmpresarial, ServicioFormatoPagareService, DatosPagareEntity } from 'src/app/services/servicio-formato-pagare.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ParametrosPagareEntity } from '../../../services/servicio-formato-pagare.service';
import { FechaService } from 'src/app/services/utils/fecha.service';
import { ExcelService } from 'src/app/services/utils/excel.service';
import { FileService } from 'src/app/services/utils/file.service';
import { saveAs } from 'file-saver';
import * as jsPDF from 'jspdf';



@Component({
  selector: 'app-header-formato-pagare',
  templateUrl: './header-formato-pagare.component.html',
  styleUrls: ['./header-formato-pagare.component.css']
})
export class HeaderFormatoPagareComponent implements OnInit {
  fechaInicial: string;
  fechaFinal: string;
  empresa: string;
  loading: boolean;
  canDownload: boolean; // Indicador que existe data
  downloading: boolean;
  mensaje: String;
  mensajeError: string; // Mensaje de error
  tablas: any;

  @Input() public codigoBaseDatos: string;
  @Input() public uncoEntidad: number;
  @Input() public objetoParametrosEntity: ParametrosPagareEntity;
  @Input() public objetoDatosPagare: DatosPagareEntity[];
  @Output() entidadEmpresarial: EventEmitter<EntidadEmpresarial>;

  constructor(private servicioFormatoPagare: ServicioFormatoPagareService,
    private servicioFecha: FechaService,
    private servicioArchivo: FileService,
    private servicioExcel: ExcelService) {

    this.loading = true;
    this.entidadEmpresarial = new EventEmitter();
  }

  ngOnInit() {
    this.init();
  }

  init() {
    this.getEntidadEmpresarial();
  }

  async getEntidadEmpresarial() {
    try {

      const response = await this.servicioFormatoPagare.getEntidadEmpresarial(this.objetoParametrosEntity, this.uncoEntidad);
      if (response != null) {
        response.subscribe((data: any) => {

          const entidad: EntidadEmpresarial = {
            unco: data.unco,
            nombreEntidad: data.dscrpcn_entdd_emprsrl,
            nit: data.idntfccn_trbtra,
            digitoVerificacion: data.dgto_vrfccn,
            direccion: data.drccn,
            telefono: data.tlfno_pbx,
            tipoDocumento: data.cdgo_tpo_dcmnto,
          };
          this.entidadEmpresarial.emit(entidad);

        }, (err: HttpErrorResponse) => {
          console.log('Error entidad empresarial', err);
          if (err.status === 500) {
            this.loading = false;
          } else {
            console.log('Error en datos entidad empresarial: ' + err);
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  onImprimir() {
    let printContents: any, popupWin: any;

    printContents = document.getElementById('pagare-print').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Pagaré </title>
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css"
          integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

  onDescargarPDF() {

    this.downloading = true;
    document.getElementById('pagare-print').style.width = '125%';
    document.getElementById('pagare-print').style.fontSize = '13px';
    this.tablas = document.getElementsByTagName('table');
    for (const iterator of this.tablas) {
      iterator.style.fontSize = '13px';
    }
    try {
      if (this.validatePDF()) {
        const dataPagina = xepOnline.Formatter.Html('pagare-print', { resolution: '200' });
        const html = `<html><head><meta charset="UTF-8"/></head><body>${dataPagina}</body></html>`;
        const response = this.servicioArchivo.generatePDF(html, 'Formato Pagaré ', 'formatoPagare');
        if (response != null) {
          response.subscribe((data: any) => {
            const filename = data.filename;
            this.servicioArchivo.downloadFile(filename)
              .subscribe((dataTemp) => {
                saveAs(dataTemp, filename);
                this.downloading = false;
              }, err => {
                this.mostrarMensaje('Error al intentar generar PDF, reporte caso inmediatamente a su administrador.');
                console.error('Error download', err);
                this.downloading = false;
              });
          }, (err: HttpErrorResponse) => {
            console.error('Error', err);
            this.mostrarMensaje('La generación PDF no se encuentra funcionando, reporte caso inmediatamente a su administrador.');
            this.downloading = false;
          });
        } else {
          console.error('Response Null');
        }
        this.downloading = false;
      } else {
        this.downloading = false;
      }
      document.getElementById('pagare-print').style.fontSize = '16px';
      this.tablas = document.getElementsByTagName('table');
      for (const iterator of this.tablas) {
        iterator.style.fontSize = '16px';
      }
      document.getElementById('pagare-print').style.width = '100%';
    } catch (e) {
      this.mostrarMensaje('Error al intentar generar archivo pdf, reporte caso al administrador');
      this.downloading = false;
      console.error(e);
    }
  }

  mostrarMensaje(mensaje: string) {
    this.mensajeError = mensaje;
    setTimeout(() => {
      this.mensajeError = null;
    }, 5000);
  }
  validatePDF(): boolean {
    if (!this.objetoDatosPagare || this.objetoDatosPagare.length < 500) {
      return true;
    } else {
      this.mostrarMensaje('El reporte supera los 500 registros, por favor genere un archivo excel.');
      return false;
    }
  }

}
